<template>
  <div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Validate input as</span>
      </div>
      <select v-model="data.validate" class="form-control">
          <option v-for="(item,index) in verifications" :value="item.toLowerCase()" :key="index">{{item}}</option>
      </select>
    </div>
  </div>
</template>


<script>
export default {
  name:'ValidateInput',
  props:{
    data: Object,
  },
  data: function(){
    return{
      verifications: ['Email','Mobile','URL','Number']
    }
  }
}
</script>
